import api from './api';
import publicApi from './publicApi';

export const trackBlogView = (slug, visitorId) => {
  return publicApi.post(`analytics/${slug}/track-views/`, {
    visitor_id: visitorId
  });
};

export const trackNewsletterCTA = (source) => {
  return publicApi.post(`analytics/newsletter-click/`, {
    source
  });
};

export const trackBannerImpression = (data) => {
    return publicApi.post(
        "analytics/adverts/impression/",
        data
    );
};

export const trackBannerClick = (data) => {
    return publicApi.post(
        "analytics/adverts/click/",
        data
    );
};

